import React, { useEffect, useState } from 'react'

// api
import { getNotesById, getOriginalPdfUrlNotesById } from '../../api/list';

// components
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';
import PDFViewer from "../notes/notes-detail/notes-docs-viewer";
import { CustomButton } from '../../components/buttons/button';

// icons
import NoContentIcon from '../../assets/icons/no-content.svg';

export default function NotesDocs({ id, heightClassName }:
  { id: string | number, heightClassName?: string }) {
  const [notesLoader, setNotesLoader] = useState(true);
  const [noteDetail, setNoteDetail] = useState<any>({});

  // pdf modal
  const [hasOriginalPdf, setHasOriginalPdf] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [loaderShowOriginalPdfButton, setLoaderShowOriginalPdfButton] = useState<boolean>(false);
  const [urlOriginalPdf, setUrlOriginalPdf] = useState<string | null>(null);
  const [originalPdfValid, setOriginalPdfValid] = useState<boolean>(false);

  const getNotesApiDetails = (id: string | number) => {
    setNotesLoader(true)
    getNotesById(id).then((res: any) => {
      if (res?.result?.data) {
        setNoteDetail(res?.result?.data)
        setHasOriginalPdf(res?.result?.data?.is_exists_source_document || false)
      }
      setNotesLoader(false)
    });
  };

  const handleShowOriginalPdf = async () => {
    setLoaderShowOriginalPdfButton(true);
    if (urlOriginalPdf && originalPdfValid) {
      setShowPdfModal(true)
      setLoaderShowOriginalPdfButton(false);
      return
    } else {
      await getOriginalPdfUrlNotesById(id).then((res: any) => {
        if (res?.result?.data) {
          if (res?.result?.data?.is_exists) {
            const source_document_url = res?.result?.data?.source_document_url
            const expiration_minutes = res?.result?.data?.expiration_minutes
            setUrlOriginalPdf(source_document_url)
            setOriginalPdfValid(true)
            setTimeout(() => {
              setOriginalPdfValid(false)
            }, expiration_minutes * 60 * 1000); // expiration_minutes minutes
          } else {
            setHasOriginalPdf(false)
            setUrlOriginalPdf(null)
            toast.error("Original PDF not found")
          }
          setShowPdfModal(true)
        }
        setLoaderShowOriginalPdfButton(false)
      });
    }
  }

  useEffect(() => {
    if (id) {
      setUrlOriginalPdf(null);
      getNotesApiDetails(id);
    }
  }, [id]);
  return (
    <div className={`relative border border-gray-200 rounded-lg shadow-sm  overflow-y-auto scrollable-hidden ${heightClassName || 'h-[calc(100vh-180px)]'}`}>
      <div className="font-normal text-gray-800 text-base bg-gray-200 py-2 px-4 rounded-t-lg sticky top-0 z-10">
        <div className="flex justify-between items-center min-h-[1.8rem]">
          <div> Note Content</div>
          <div>
            {hasOriginalPdf && <CustomButton
              buttonStyle="text-white !bg-[#215564] px-[13px] py-[4px] text-[12px] font-semibold leading-[17px] border-[#E8ECF4] "
              buttonName="Source PDF"
              primary={false}
              disable={loaderShowOriginalPdfButton}
              onClick={handleShowOriginalPdf}
            // onClick={() => setShowPdfModal(true)}
            />}
          </div>
        </div>
      </div>
      {notesLoader ? (
        <Skeleton height="99%" className="rounded-lg" />
      ) :
        (
          noteDetail.notes ? (
            <div dangerouslySetInnerHTML={{ __html: noteDetail.notes || '' }} className="p-3" />
          ) : (
            <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center text-gray-500 h-full`}>
              <img src={NoContentIcon} alt="No content" className="w-[10rem] h-[10rem]" />
              <p className="mt-1 text-md font-normal">No content found</p>
            </div>

          )
        )
      }
      {hasOriginalPdf && (
        <PDFViewer
          pdfUrl={urlOriginalPdf || ''}
          title="Source PDF"
          showModal={showPdfModal}
          setShowModal={setShowPdfModal}
        />
      )}
    </div>
  )
}
